import CardWide from './CardWide';

export default CardWide;
